import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilitySharedService {
  setUtilityId(id: any) {
    localStorage.setItem('utilityId', String(id));
  }

  getUtilityId(): number | null {
    const item = localStorage.getItem('utilityId');
    if (item === null) return null;
    const utilityId = parseInt(item, 10);
    return isNaN(utilityId) ? null : utilityId;
  }

  removeUtilityId() {
    localStorage.removeItem('utilityId');
  }
}
